import { render, staticRenderFns } from "./ApplicantDetail.vue?vue&type=template&id=554ae5ed&scoped=true&"
import script from "./ApplicantDetail.vue?vue&type=script&lang=js&"
export * from "./ApplicantDetail.vue?vue&type=script&lang=js&"
import style0 from "./ApplicantDetail.vue?vue&type=style&index=0&id=554ae5ed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554ae5ed",
  null
  
)

export default component.exports